// extracted by mini-css-extract-plugin
module.exports = {"container":"FormComponent_container__2nfde","skipPaymentButton":"FormComponent_skipPaymentButton__15th7","skipPaymentContainer":"FormComponent_skipPaymentContainer__1InCh"};